import { motion, AnimatePresence } from 'framer-motion'
import { WaveformAnimation } from './WaveformAnimation'

interface SpeakingIndicatorProps {
  isSpeaking: boolean
  botName: string
  primaryColor: string
}

export function SpeakingIndicator({ isSpeaking, botName, primaryColor }: SpeakingIndicatorProps) {
  return (
    <AnimatePresence>
      {isSpeaking && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          style={{
            padding: 16,
            background: `linear-gradient(135deg, ${primaryColor}10, ${primaryColor}20)`,
            borderBottom: '1px solid #e5e7eb',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <span style={{ fontSize: 13, color: primaryColor, fontWeight: 500 }}>
            {botName} is speaking...
          </span>
          <WaveformAnimation isActive={isSpeaking} color={primaryColor} height={28} barCount={12} />
        </motion.div>
      )}
    </AnimatePresence>
  )
}
